export default {
  presets: {
    light: {
      backgroundPrimary: '#111A16',
      backgroundSecondary: '#0E1411',
      backgroundCardPrimary: '#F7F9F9',
      backgroundCardSecondary: '#ECFDE6',
      success: '#5AA432',
      info: '#5AA432',
      danger: '#E42222',
      warning: '#FFD43A',
    },
    dark: {
      backgroundCardPrimary: '#111827',
      backgroundCardSecondary: '#0f172a',
    },
  },
}
